import { useNavigate, useParams } from "react-router";
import Purchase from "./orders/Purchase";
import { LessonDataI, LiveSessionDataI } from "./quiz/typesAndEnums";
import { Button } from "./ui/button";

const PurchaseScreen = ({
  lessonData,
  isMobile,
  isRepurchase = false,
}: {
  lessonData: LessonDataI | LiveSessionDataI;
  isMobile: boolean;
  isRepurchase?: boolean;
}) => {
  const navigate = useNavigate();
  const { schoolgrade, group } = useParams();
  return (
    <div
      className="fade-in m-0 p-4 w-full grow bg-ea-base flex flex-col items-center justify-center"
      style={{ minHeight: "100vh" }}
    >
      <Button
        className="m-0 p-0 fixed"
        style={{ top: "2rem", left: "2rem", width: "4rem", height: "3rem" }}
        onClick={() => navigate(`/${schoolgrade}/${group}/lessons`)}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          fill="white"
          className="bi bi-arrow-left"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
          />
        </svg>
      </Button>
      {isMobile ? (
        <div className="w-full p-4 bg-white shadow rounded-lg flex flex-col items-center justify-center">
          <h3 className="text-center fs-5 mb-3 bg-primary p-3 text-white rounded-lg shadow">
            اختر وسيلة دفع لشراء الحصة
          </h3>
          <Purchase lessonData={lessonData} isMobile={isMobile} />
        </div>
      ) : (
        <div className="w-1/2 p-4 bg-white shadow rounded-lg flex flex-col items-center justify-center">
          <h3 className="text-center mb-3 bg-primary p-3 text-white rounded-lg shadow">
            اختر وسيلة دفع لشراء الحصة
          </h3>
          <Purchase lessonData={lessonData} isMobile={isMobile} />
        </div>
      )}
    </div>
  );
};

export default PurchaseScreen;
